/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const CarouselSvg = () => (
  <svg width="1.1em" height="1.1em" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.4" y="1.4" width="5.2" height="6.2" fill="white" stroke="black" strokeWidth="0.8"/>
    <rect x="5.4" y="1.4" width="5.2" height="6.2" fill="white" stroke="black" strokeWidth="0.8"/>
    <rect x="2.4" y="0.4" width="6.2" height="8.2" fill="white" stroke="black" strokeWidth="0.8"/>
  </svg>
);

export const CarouselIcon = props => <Icon component={CarouselSvg} {...props} />;
